export const SET_POST_DETAIL = "SET_POST_DETAIL";